export enum USER_TABLE_TAB_ENUM {
    INVITED = 'invited',
    ACTIVE = 'active',
    INACTIVE = 'inactive'
}
